// const URL_ = "http://localhost:9080/";
const URL_ = "http://admin.gpscpc.net:9080/";
const URL_THINGS_EXPORT = URL_ + "things/export/";
const URL_PRODUCT_TEST_EXPORT = URL_ + "api/product-export/";
const URL_CARD_EXPORT = URL_ + "payment/card-export/";
export default {
  URL_THINGS_EXPORT,
  URL_PRODUCT_TEST_EXPORT,
  URL_CARD_EXPORT
}



// WEBPACK FOOTER //
// ./src/constants/Net.Constants.js